import { GenIcon } from '../helpers/IconBase.es.js';

const BadgesColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: {
          x: "4",
          y: "4",
          width: "16",
          height: "16",
          rx: "8",
          fill: "#DA4343"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12.9033 15H11.7217V9.29199L9.97852 9.8877V8.88672L12.752 7.86621H12.9033V15Z",
          fill: "white"
        }
      }
    ]
  })(props);
};

export { BadgesColored };
